import router from './router'
import MainModule from '@/modules/Core'
import UserModule from '@/modules/User'
import AuthModule from '@/modules/Auth'
import SecretariatModule from '@/modules/Secretariat'
import OrgChartModule from '@/modules/OrgChart'
import ReminderModule from '@/modules/Reminder'
import RecruitmentModule from '@/modules/Recruitment'
import NewsModule from '@/modules/News'
import ArticleModule from '@/modules/Article'
import EvaluationModule from '@/modules/Evaluation'
function flattenModules(modules: Modules): Array<[string, Module]> {
  const entries: Array<[string, Module]> = []

  Object.keys(modules).forEach((moduleKey) => {
    const qualifiedKey = moduleKey
    const module = modules[moduleKey]
    entries.push([qualifiedKey, module])

    if (module.subModules) {
      entries.push(...flattenModules(module.subModules))
    }
  })

  return entries
}

export function registerModules(modules: Modules) {
  const flatModules = flattenModules(modules)

  flatModules.forEach(([, module]) => {
    if (module.router) {
      module.router(router)
    }
  })
}

registerModules({
  user: UserModule,
  main: MainModule,
  auth: AuthModule,
  secretariat: SecretariatModule,
  orgChart: OrgChartModule,
  reminder: ReminderModule,
  recruitment: RecruitmentModule,
  news: NewsModule,
  Article: ArticleModule,
  evaluation: EvaluationModule,
})
